<p>assign-bed works!</p>
